import {
  correspondenceDiscardCorrespondenceDraftMutation,
  useHeyApi,
} from "@platform/api";
import { useMutation } from "@tanstack/react-query";

export interface DiscardCorrespondenceDraft {
  discard: (threadId: string, messageId: string) => void;
  /** The draft currently being thrown away, so only its control disables. */
  discardingId?: string;
}

/**
 * Throws an unsent reply away.
 *
 * The analyst is never sent: the BFF takes it from the caller's token,
 * because the review records who rejected the draft and an address from the
 * body would attribute one analyst's decision to another.
 *
 * Invalidated through the Correspondence tag rather than a hand-built key, so
 * the drafts listing, the rail's count and the row badge all follow — all
 * three descend from the same draft rows.
 */
export const useDiscardCorrespondenceDraft = (): DiscardCorrespondenceDraft => {
  const { centroPortalClient, invalidateQuery } = useHeyApi();

  const { mutate, isPending, variables } = useMutation({
    ...correspondenceDiscardCorrespondenceDraftMutation({
      client: centroPortalClient,
    }),
    onSuccess: () => invalidateQuery({ tags: ["Correspondence"] }),
  });

  return {
    discard: (threadId, messageId) => mutate({ path: { threadId, messageId } }),
    discardingId: isPending ? variables?.path?.messageId : undefined,
  };
};
